import React from 'react';
import { RouterProvider } from 'react-router-dom';
import { FullyCenterLoader } from '@/components/FullyCenter/Loader';
import { router } from '@/routes';

export function Router() {
  return <RouterProvider router={router} fallbackElement={<FullyCenterLoader />} />;
}
